import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import speakers from "../data/speakersData";
import { Link } from "react-router-dom";

const SpeakerDetails = () => {
  const { id } = useParams();
  const [bio, setBio] = useState("");
  const speaker = speakers.find((s) => s.id === id);

  useEffect(() => {
    if (id) {
      import(`../data/bios/${id}.md`)
        .then((res) => res.default) // Assuming you have a webpack loader for markdown
        .then((filePath) => fetch(filePath)) // Fetch the content from the imported file path
        .then((r) => r.text())
        .then(setBio)
        .catch((error) => {
          console.error("Error loading bio:", error);
          setBio("Biography not found.");
        });
    }
  }, [id]);

  if (!speaker) return <p>Speaker not found</p>;

  return (
    <div className=" text-white font-outfit px-6 py-16 max-w-6xl mx-auto">
      <div className="flex flex-col md:flex-row gap-8 items-start xs:items-center xxs:items-center ">
        <div className="flex-shrink-0 flex flex-col gap-4 ">
          <img
            src={speaker.image}
            alt={speaker.name}
            className="rounded-xl w-full max-w-sm h-[20rem] object-cover mix-blend-luminosity"
          />

          <Link
            to="/speakers"
            className="inline-block text-center  mb-6 bg-gradient-to-r from-[#04DDAD] to-[#34ACAC] text-white text-sm font-semibold px-4 py-3 rounded-xl hover:opacity-90 transition"
          >
            ← Back to All Speakers
          </Link>
        </div>
        <div className="flex-1">
          <h1 className="text-3xl font-bold mb-2">{speaker.name}</h1>
          <h2 className="text-xl mb-6">{speaker.title}</h2>
          <div className="prose prose-invert">
            <ReactMarkdown>{bio}</ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeakerDetails;
